export default __webpack_public_path__ + "static/media/Arm-straps of the Faceless Chaos.4a6d80d9.jpg";